const AccordionBlockIcon = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="24"
    height="24"
    viewBox="0 0 24 24"
  >
    <path fill="#333" d="M0 0h24v2H0z" />
    <path fill="#ffd400" d="M2 8h20v8H2z" />
    <path d="M22 8v8H2V8h20m2-2H0v12h24V6zM0 22h24v2H0z" fill="#333" />
  </svg>
);

export default AccordionBlockIcon;
